import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Form, Menu, Switch } from "antd";

import partnersApi from "../apis/Partners.api";
import EditProfile from "../components/channel/EditProfile";
import EditCategory from "../components/edit/EditCategory";
import EditCombinations from "../components/edit/EditCombinations";
import EditCommunity from "../components/edit/EditCommunity";
import EditCommunityLonglife from "../components/edit/EditCommunityLonglife";
import EditFaq from "../components/edit/EditFaq";
import EditFunctions from "../components/edit/EditFunctions";
import EditHotKeyword from "../components/edit/EditHotKeyword";
import EditIngredients from "../components/edit/EditIngredients";
import EditLink from "../components/edit/EditLink";
import EditSearchExample from "../components/edit/EditSearchExample";
import LinkComponent from "../components/layout/LinkComponent";
import { setUser } from "../redux/store/auth/authDuck";
import { setReduxChannel } from "../redux/store/channel/channelDuck";
import apiService from "../utils/ApiService";

const api = new apiService();
const EditChannel = () => {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.auth.user);
	const setChannel = (value) => dispatch(setReduxChannel(value));
	const [channelInfo, setChannelInfo] = useState({});
	// const [selectKey, setSelectKey] = useState("community");
	const [selectKey, setSelectKey] = useState("category");

	// 변화 여부 판단
	const [isChange, setIsChange] = useState(false);

	const channelMenu =
		user?.role === "level_1" || user?.role === "super_admin"
			? [
					// {label: '성분별', key: 'ingredients'}, // remember to pass the key prop
					// {label: '고민별', key: 'functions'}, // which is required
					// {label: '조합추천', key: 'combinations'}, // which is required
					{ label: "카테고리", key: "category" },
					{ label: "검색관리", key: "search" },
					{ label: "자주묻는 질문", key: "faq" },
					// {label: '1:1 상담', key: 'inquiry'},
					// {label: '유튜브', key: 'youtube'},
					// {label: '인스타그램', key: 'instagram'},
					{ label: "프로필 수정", key: "profile" },
					{
						// label: user?.id === 9 ? "오징어 하우스" : "내 소통글",
						label: "내 소통글",
						key: "community",
					},
					{ label: "게시글", key: "health_magazine" },
			  ]?.filter((item) => !!item)
			: [
					{ label: "카테고리", key: "category" },
					// {label: '검색관리', key: 'search'},
					// {label: '자주묻는 질문', key: 'faq'},
					// {label: '프로필 수정', key: 'profile'},
					{ label: "내 소통글", key: "community" },
					{ label: "게시글", key: "health_magazine" },
			  ]?.filter((item) => !!item);

	useEffect(() => {
		window.scrollTo({
			top: 0,
		});
	}, []);

	useEffect(() => {
		getInfo(0);
	}, []);

	const getInfo = async () => {
		let param = {
			// userId: user?.id,
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			offset: 0,
			pageSize: 1,
		};
		const res = await partnersApi.readChannel(param);
		const rsp = await partnersApi.getMenuChannel({
			influencerId: res.result?.user_id,
		});
		const rsq = await partnersApi.getUserInfo({ userId: user.id });
		if (res.code === 200 && rsp.code === 200 && rsq.code === 200) {
			setChannelInfo({
				...res.result,
				inquiry_link: rsq.result?.inquiry_link,
				youtube_link: rsq.result?.youtube_link,
				instagram_link: rsq.result?.instagram_link,
				ingredient_menu_show: rsp.result?.ingredient_menu_show,
				function_menu_show: rsp.result?.function_menu_show,
				combination_menu_show: rsp.result?.combination_menu_show,
				inquiry_menu_show: rsp.result?.inquiry_menu_show,
				quick_menu_show: rsp.result?.quick_menu_show,
				greetings1: rsp.result?.greetings1,
				greetings2: rsp.result?.greetings2,
				greetings3: rsp.result?.greetings3,
				greetings4: rsp.result?.greetings4,
				placeholder: rsq.result?.placeholder,
				// email: rsq?.user_id,
			});
			setChannel({
				...res.result,
				inquiry_link: rsq.result?.inquiry_link,
				youtube_link: rsq.result?.youtube_link,
				instagram_link: rsq.result?.instagram_link,
				ingredient_menu_show: rsp.result?.ingredient_menu_show,
				function_menu_show: rsp.result?.function_menu_show,
				combination_menu_show: rsp.result?.combination_menu_show,
				inquiry_menu_show: rsp.result?.inquiry_menu_show,
				quick_menu_show: rsp.result?.quick_menu_show,
				greetings1: rsp.result?.greetings1,
				greetings2: rsp.result?.greetings2,
				greetings3: rsp.result?.greetings3,
				greetings4: rsp.result?.greetings4,
				placeholder: rsq.result?.placeholder,
				// email: rsq?.user_id,
			});
			dispatch(
				setUser({
					...user,
					inquiry_link: rsq.result?.inquiry_link,
					youtube_link: rsq.result?.youtube_link,
					instagram_link: rsq.result?.instagram_link,
					ingredient_menu_show: rsp.result?.ingredient_menu_show,
					function_menu_show: rsp.result?.function_menu_show,
					combination_menu_show: rsp.result?.combination_menu_show,
					quick_menu_show: rsp.result?.quick_menu_show,
					greetings1: rsp.result?.greetings1,
					greetings2: rsp.result?.greetings2,
					greetings3: rsp.result?.greetings3,
					greetings4: rsp.result?.greetings4,
					placeholder: rsq.result?.placeholder,
				})
			);
		}
	};
	// console.log(user);

	/**
	 * 해당 카테고리 표기 수정
	 * @returns {Promise<void>}
	 */
	// const submitMenuEdit = async (value) => {
	//     let param = {
	//         id: user.id,
	//         ingredient_menu_show: channelInfo?.ingredient_menu_show,
	//         function_menu_show: channelInfo?.function_menu_show,
	//         combination_menu_show: channelInfo?.combination_menu_show,
	//         quick_menu_show: value,
	//         updated_by: user.id,
	//     }
	//     const res = await partnersApi.editMenuChannel(param);
	//     if (res.code === 200) {
	//         getInfo();
	//         setChannel({
	//             ...channelInfo,
	//             param
	//         });
	//     }
	// }

	return (
		<div className="main-wrap">
			<div className="max-width-apply">
				<LinkComponent />
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					<h1 className={`main-title`} id={`main-title`}>
						사이트 관리
					</h1>
					{/*<Form.Item*/}
					{/*    label="메뉴 노출"*/}
					{/*    valuePropName="checked"*/}
					{/*    className={`switch-form`}*/}
					{/*    colon={false}*/}
					{/*>*/}
					{/*    <Switch*/}
					{/*        checked={channelInfo.quick_menu_show}*/}
					{/*        onChange={submitMenuEdit}*/}
					{/*    />*/}
					{/*</Form.Item>*/}
				</div>

				<div className={`main-nav`}>
					{channelMenu?.map((item, idx) => (
						<button
							className={selectKey === item.key ? "clicked" : ""}
							onClick={() => setSelectKey(item.key)}
							key={`사이트관리 메뉴바 ${idx}`}
							// onClick={() => history.push(`/group_buying`)}
						>
							{item?.label}
						</button>
					))}
				</div>
				{/*<Menu*/}
				{/*    items={channelMenu}*/}
				{/*    mode={`horizontal`}*/}
				{/*    defaultSelectedKeys={"ingredients"}*/}
				{/*    onClick={e => setSelectKey(e.key)}*/}
				{/*    className={`edit-channel-menu`}*/}
				{/*/>*/}
				{/*<EditCategory*/}
				{/*    channelInfo={channelInfo}*/}
				{/*    getInfo={getInfo}*/}
				{/*/>*/}
				{/*{selectKey === "ingredients" ? (*/}
				{/*    <EditIngredients*/}
				{/*        channelInfo={channelInfo}*/}
				{/*        getInfo={getInfo}*/}
				{/*    />*/}
				{/*) : selectKey === "functions" ? (*/}
				{/*    <EditFunctions*/}
				{/*        channelInfo={channelInfo}*/}
				{/*        getInfo={getInfo}*/}
				{/*    />*/}
				{/*) : selectKey === "combinations" ? (*/}
				{/*    <EditCombinations*/}
				{/*        channelInfo={channelInfo}*/}
				{/*        getInfo={getInfo}*/}
				{/*    />*/}
				{/*) : */}
				{selectKey === "community" ? (
					<EditCommunity />
				) : selectKey === "health_magazine" ? (
					<EditCommunityLonglife />
				) : selectKey === "category" ? (
					<EditCategory />
				) : selectKey === "search" ? (
					<>
						<EditSearchExample
							getInfo={getInfo}
							user={user}
							setIsChange={setIsChange}
						/>
						<EditHotKeyword
							channelInfo={channelInfo}
							getInfo={getInfo}
							user={user}
							// setIsChange={setIsChange}
						/>
					</>
				) : selectKey === "faq" ? (
					<EditFaq channelInfo={channelInfo} getInfo={getInfo} user={user} />
				) : selectKey === "profile" ? (
					<EditProfile
						channelInfo={channelInfo}
						getInfo={getInfo}
						user={user}
					/>
				) : (
					// <EditLink type={selectKey}/>
					<></>
				)}
			</div>
		</div>
	);
};
export default EditChannel;
